"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingTempFileResponseDto = instanceOfListingTempFileResponseDto;
exports.ListingTempFileResponseDtoFromJSON = ListingTempFileResponseDtoFromJSON;
exports.ListingTempFileResponseDtoFromJSONTyped = ListingTempFileResponseDtoFromJSONTyped;
exports.ListingTempFileResponseDtoToJSON = ListingTempFileResponseDtoToJSON;
exports.ListingTempFileResponseDtoToJSONTyped = ListingTempFileResponseDtoToJSONTyped;
/**
 * Check if a given object implements the ListingTempFileResponseDto interface.
 */
function instanceOfListingTempFileResponseDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function ListingTempFileResponseDtoFromJSON(json) {
    return ListingTempFileResponseDtoFromJSONTyped(json, false);
}
function ListingTempFileResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
function ListingTempFileResponseDtoToJSON(json) {
    return ListingTempFileResponseDtoToJSONTyped(json, false);
}
function ListingTempFileResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
